import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MemoryTokenService, TOKEN_STORAGE_SERVICE } from './services/auth/itoken.storage';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './services/auth/auth.interceptor';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    {
      provide: TOKEN_STORAGE_SERVICE,
      useClass: MemoryTokenService
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ]
})
export class CoreModule { }
